<div class="content">
  <div class="card">
    <div class="card-content">
      <div class="card-body">

        <button *ngIf='!isList' routerLink="/products" title="{{ 'inputs.back' | translate }}" mat-icon-button>
          <mat-icon>keyboard_backspace</mat-icon>
          {{ 'inputs.back' | translate }}
        </button>

        <h1 *ngIf='isList'>{{ 'titles.list.product' | translate }}</h1>
        <h1 *ngIf='!isList'>{{ 'titles.edit.product' | translate }}</h1>
        <div *ngIf='!isList && !isNew'>
          <p style="float: left;">
            <a [href]="productForm.value.product_image" target="_blank"><img
                [src]="productForm.value.product_image"></a>
          </p>
          <p> {{ 'inputs.creation_date' | translate }}: {{creation_date | date:'d/M/Y, H:mm:ss'}} <br>
            {{ 'inputs.modification_date' | translate }}: {{modification_date | date:'d/M/Y, H:mm:ss'}}
          </p>
        </div>
        <div style="clear: left;"></div>

        <div class="media-body">

          <mat-form-field *ngIf='isList'>
            <mat-label>{{ 'inputs.search' | translate }}</mat-label>
            <input matInput (keyup)="applyFilter($event)" placeholder="{{ 'inputs.search' | translate }}" #input>
          </mat-form-field>
          <div *ngIf='isList'>
            <table mat-table [dataSource]="dataSource" matSort>

              <ng-container matColumnDef="name_es" style="display: {{'es' | translate}}">
                <th mat-header-cell *matHeaderCellDef mat-sort-header style="display: {{'es' | translate}}"> {{
                  'tables.name' | translate }} </th>
                <td mat-cell *matCellDef="let element" (click)="goTo(element.id)" style="display: {{'es' | translate}}">
                  {{element.name_es}} </td>
              </ng-container>
              <ng-container matColumnDef="name_en" style="display: {{'en' | translate}}">
                <th mat-header-cell *matHeaderCellDef mat-sort-header style="display: {{'en' | translate}}"> {{
                  'tables.name' | translate }} </th>
                <td mat-cell *matCellDef="let element" (click)="goTo(element.id)" style="display: {{'en' | translate}}">
                  {{element.name_en}} </td>
              </ng-container>
              <ng-container matColumnDef="name_cat" style="display: {{'cat' | translate}}">
                <th mat-header-cell *matHeaderCellDef mat-sort-header style="display: {{'cat' | translate}}"> {{
                  'tables.name' | translate }} </th>
                <td mat-cell *matCellDef="let element" (click)="goTo(element.id)"
                  style="display: {{'cat' | translate}}"> {{element.name_cat}} </td>
              </ng-container>


              <ng-container matColumnDef="priority">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'tables.priority' | translate }} </th>
                <td mat-cell *matCellDef="let element" (click)="goTo(element.id)"> {{element.priority}}</td>
              </ng-container>

              <!-- <ng-container matColumnDef="catalogue">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'tables.catalogue' | translate }} </th>
                <td mat-cell *matCellDef="let element" (click)="goTo(element.id)"> {{element.catalogue_name}}</td>
              </ng-container> -->

              <ng-container matColumnDef="available">
                <th mat-header-cell *matHeaderCellDef mat-sort-header fxHide.lt-sm> {{ 'tables.available' | translate }}
                </th>
                <td mat-cell *matCellDef="let element" (click)="goTo(element.id)" fxHide.lt-sm> {{ 'tables.' +
                  element.available | translate }} </td>
              </ng-container>

              <ng-container matColumnDef="modification_date">
                <th mat-header-cell *matHeaderCellDef mat-sort-header fxHide.lt-sm> {{ 'tables.modification_date' |
                  translate }} </th>
                <td mat-cell *matCellDef="let element" (click)="goTo(element.id)" fxHide.lt-sm>
                  {{element.modification_date | date: 'yyyy-MM-dd H:mm:ss'}} </td>
              </ng-container>

              <ng-container matColumnDef="actions" class="actionsColumn">
                <th mat-header-cell *matHeaderCellDef> {{ 'tables.actions' | translate }} </th>
                <td mat-cell *matCellDef="let element">
                  <!-- <button mat-icon-button matTooltip="Click to Delete related information" class="iconbutton"
                    (click)="delete(element.id)" color="warn">
                    <mat-icon>delete</mat-icon>
                  </button> -->
                  <button mat-icon-button (click)="deleteProduct(element.id)">
                    <mat-icon>delete</mat-icon>
                  </button>
                  <button mat-icon-button matTooltip="{{'inputs.edit' | translate}}" (click)="goTo(element.id)">
                    <mat-icon>edit</mat-icon>
                  </button>

                  <button mat-icon-button matTooltip="{{ 'buttons.duplicate_product' | translate }}"
                    (click)="duplicateProduct(element.id)">
                    <mat-icon>content_copy</mat-icon>
                  </button>

                </td>
              </ng-container>


              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
              <tr class="mat-row" *matNoDataRow>
                <td class="mat-cell" colspan="4">
                  <span *ngIf="showProductTableProgressBar">{{ 'tables.loading' | translate }}</span>
                  <span *ngIf="!showProductTableProgressBar">{{ 'tables.no_data_found' | translate}}</span>
                </td>
              </tr>
            </table>
            <mat-progress-bar *ngIf="showProductTableProgressBar" mode="indeterminate"></mat-progress-bar>
            <mat-paginator [pageSize]="pageSize" [pageIndex]="pageIndex" [pageSizeOptions]="[100, 10, 20,50]"
              showFirstLastButtons></mat-paginator>

          </div>


          <!-- <mat-card *ngIf='!isList'> -->
          <div class="contenedor" [formGroup]="productForm" *ngIf='!isList'>
            <input matInput [hidden]="true" [formControlName]="'id'" type="text" placeholder="id">
            <div class="name">
              <mat-form-field>
                <input matInput required [formControlName]="'name_es'" type="text"
                  placeholder="{{ 'inputs.name_es' | translate }}">
              </mat-form-field>

              <mat-form-field>
                <input matInput required [formControlName]="'name_cat'" type="text"
                  placeholder="{{ 'inputs.name_cat' | translate }}">
              </mat-form-field>

              <mat-form-field>
                <input matInput required [formControlName]="'name_en'" type="text"
                  placeholder="{{ 'inputs.name_en' | translate }}">
              </mat-form-field>
            </div>

            <!-- <mat-form-field style="max-width: 150px;">
              <input matInput required [formControlName]="'priority'" autocomplete="off" type="number"
                placeholder="{{ 'inputs.priority' | translate }}">
            </mat-form-field> -->
            <!-- <mat-form-field>
                    <textarea matInput required [formControlName]="'description'" type="text" placeholder="{{ 'inputs.description' | translate }}"></textarea>
                </mat-form-field> -->
          </div>
          <div *ngIf='!isList' class="product-description-table-wrapper">
            <div class="description-table-header">
              <span>{{ 'titles.list.product_description' | translate }}</span>

              <button [disabled]="editModeState.newEntry" mat-flat-button (click)="openEditMode()" class="btn">
                <mat-icon>playlist_add</mat-icon>
                <span>{{ 'buttons.add_description' | translate }}</span>
              </button>
            </div>
            <table mat-table #table [dataSource]="data" class="mat-elevation-z8 description-table" cdkDropList
              [cdkDropListData]="data" (cdkDropListDropped)="drop($event)">

              <form [formGroup]="productDescriptionForm">

                <ng-container matColumnDef="unit">
                  <th mat-header-cell *matHeaderCellDef> {{ 'tables.unit' | translate }} </th>
                  <td mat-cell *matCellDef="let element">
                    <span *ngIf="editModeState.id != element.id">{{element.unit}}</span>
                    <mat-form-field *ngIf="editModeState.open && editModeState.id == element.id">
                      <input matInput type="number" name="unit" formControlName="unit" min="1">
                    </mat-form-field>
                  </td>
                  <td mat-footer-cell *matFooterCellDef>
                    <mat-form-field *ngIf="editModeState.open && editModeState.newEntry">
                      <input matInput type="number" name="unit" formControlName="unit" min="1">
                    </mat-form-field>
                  </td>
                </ng-container>

                <ng-container matColumnDef="description_es">
                  <th mat-header-cell *matHeaderCellDef> {{ 'tables.description_es' | translate }} </th>
                  <td mat-cell *matCellDef="let element">
                    <span *ngIf="editModeState.id != element.id">{{element.description_es}}</span>
                    <mat-form-field *ngIf="editModeState.open && editModeState.id == element.id">
                      <input matInput type="text" name="description_es" formControlName="description_es">
                    </mat-form-field>
                  </td>
                  <td mat-footer-cell *matFooterCellDef>
                    <mat-form-field *ngIf="editModeState.open && editModeState.newEntry">
                      <input matInput type="text" name="description_es" formControlName="description_es">
                    </mat-form-field>
                  </td>
                </ng-container>

                <ng-container matColumnDef="description_cat">
                  <th mat-header-cell *matHeaderCellDef> {{ 'tables.description_cat' | translate }} </th>
                  <td mat-cell *matCellDef="let element">
                    <span *ngIf="editModeState.id != element.id">{{element.description_cat}}</span>
                    <mat-form-field *ngIf="editModeState.open && editModeState.id == element.id">
                      <input matInput type="text" name="description_cat" formControlName="description_cat">
                    </mat-form-field>
                  </td>
                  <td mat-footer-cell *matFooterCellDef>
                    <mat-form-field *ngIf="editModeState.open && editModeState.newEntry">
                      <input matInput type="text" name="description_cat" formControlName="description_cat">
                    </mat-form-field>
                  </td>
                </ng-container>

                <ng-container matColumnDef="description_en">
                  <th mat-header-cell *matHeaderCellDef> {{ 'tables.description_en' | translate }} </th>
                  <td mat-cell *matCellDef="let element">
                    <span *ngIf="editModeState.id != element.id">{{element.description_en}}</span>
                    <mat-form-field *ngIf="editModeState.open && editModeState.id == element.id">
                      <input matInput type="text" name="description_en" formControlName="description_en">
                    </mat-form-field>
                  </td>
                  <td mat-footer-cell *matFooterCellDef>
                    <mat-form-field *ngIf="editModeState.open && editModeState.newEntry">
                      <input matInput type="text" name="description_en" formControlName="description_en">
                    </mat-form-field>
                  </td>
                </ng-container>

                <ng-container matColumnDef="actions">
                  <th mat-header-cell *matHeaderCellDef></th>
                  <td mat-cell *matCellDef="let element">
                    <button mat-icon-button (click)="deleteItem(element)" class="delete-button">
                      <mat-icon>delete</mat-icon>
                    </button>
                    <button *ngIf="editModeState.id != element.id" mat-icon-button (click)="openEditMode(element)"
                      class="edit-button">
                      <mat-icon>edit</mat-icon>
                    </button>
                    <button *ngIf="editModeState && editModeState.id == element.id" mat-icon-button type="reset"
                      (click)="productDescriptionHandler(productDescriptionForm, element.id)" class="confirm-button">
                      <mat-icon>check</mat-icon>
                    </button>
                  </td>
                  <td mat-footer-cell *matFooterCellDef>
                    <button *ngIf="editModeState.open && editModeState.newEntry" mat-icon-button
                      (click)="closeEditMode()" class="delete-button">
                      <mat-icon>close</mat-icon>
                    </button>
                    <button *ngIf="editModeState.open && editModeState.newEntry" mat-icon-button
                      (click)="productDescriptionHandler(productDescriptionForm)" class="confirm-button">
                      <mat-icon>playlist_add_check</mat-icon>
                    </button>

                  </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="descriptionTableColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: descriptionTableColumns;" cdkDrag [cdkDragData]="row"></tr>
                <tr class="mat-row" *matNoDataRow>
                  <td class="mat-cell" colspan="4">
                    <span *ngIf="showProductDescriptionProgressBar">{{ 'tables.loading' | translate }}</span>
                    <span *ngIf="!showProductDescriptionProgressBar">{{ 'tables.no_data_found' | translate}}</span>
                  </td>
                </tr>

                <tr mat-footer-row *matFooterRowDef="descriptionTableColumns"></tr>

              </form>

            </table>
            <mat-progress-bar *ngIf="showProductDescriptionProgressBar" mode="indeterminate"></mat-progress-bar>

          </div>

          <div class="contenedor" [formGroup]="productForm" *ngIf='!isList'>
            <span style="margin-bottom: 8px;">{{ 'titles.list.select_type' | translate }}</span>
            <mat-checkbox [formControlName]="'individual_photo'" (change)="setGiftType(isGift.checked, 'individual_photo')" [color]="'primary'">{{ 'captions.individual_photo' |
              translate }}
            </mat-checkbox>
            <mat-checkbox [formControlName]="'multiple_photo'" (change)="setGiftType(isGift.checked, 'multiple_photo')" [color]="'primary'">{{ 'captions.multiple_photo' |
              translate }}
            </mat-checkbox>
            <mat-checkbox [formControlName]="'class_group_photo'" (change)="setGiftType(isGift.checked, 'class_group_photo')" [color]="'primary'">{{ 'captions.class_group_photo' |
              translate }}
            </mat-checkbox>
            <mat-checkbox [formControlName]="'funny_photo'" (change)="setGiftType(isGift.checked, 'funny_photo')" [color]="'primary'">{{ 'captions.funny_photo' | translate }}
            </mat-checkbox>
            <mat-form-field style="max-width: 150px;">
              <input matInput required [formControlName]="'value'" autocomplete="off" type="number"
                placeholder="{{ 'inputs.value' | translate }}">
            </mat-form-field>
            <mat-form-field style="max-width: 150px;">
              <input matInput required [formControlName]="'value_tax'" autocomplete="off" type="number"
                placeholder="{{ 'inputs.value_tax' | translate }}">
            </mat-form-field>
            <mat-form-field class="columns">
              <mat-label *ngIf="selectedFiles; else newFile">{{selectedFiles.item(0).name}}</mat-label>
              <ng-template #newFile>
                <mat-label>{{ 'inputs.choose_image' | translate }}</mat-label>
              </ng-template>
              <input matInput disabled>
              <button mat-icon-button matSuffix (click)="fileInput.click()">
                <mat-icon>attach_file</mat-icon>
              </button>
              <input hidden (change)="selectFile($event)" #fileInput type="file" id="file" accept={{type_accept}}>
            </mat-form-field>
            <mat-checkbox [formControlName]="'available'" #available [color]="'primary'">{{ 'inputs.available' | translate }}
            </mat-checkbox>
            <mat-checkbox [formControlName]="'not_send_to_lab'" #notSendToLab [color]="'primary'">{{
              'inputs.not_send_to_lab' | translate }}
            </mat-checkbox>
            <mat-checkbox [formControlName]="'is_gift'" #isGift (change)="setGiftDefault()" [color]="'primary'">{{ 'inputs.gift' | translate }}
            </mat-checkbox>
            <mat-checkbox #addGift [formControlName]="'add_gift'" [color]="'primary'" [checked]="isGift.checked? false : null" [disabled]="isGift.checked">{{ 'inputs.add_gift' | translate }}
            </mat-checkbox>
            <mat-form-field appearance="fill" *ngIf="addGift.checked">
              <mat-label>{{ 'inputs.select_gifts' | translate }}</mat-label>
              <mat-select [formControlName]="'gift_list'" multiple>
                <mat-option *ngFor="let gift of gifts" [value]="gift.id">{{gift.name}}</mat-option>
              </mat-select>
            </mat-form-field>

            <!-- <mat-checkbox [formControlName]="'downloadable'" [color]="'primary'">{{ 'inputs.downloadable' | translate }}
            </mat-checkbox> -->

            <!-- <mat-form-field appearance="legacy">
              <mat-label>{{ 'inputs.catalogs' | translate }}</mat-label>
              <mat-select matNativeControl [formControlName]="'catalogue'">
                <mat-option *ngFor="let catalogue of catalogs" [value]="catalogue.id">
                  {{catalogue.name}}
                </mat-option>
              </mat-select>
            </mat-form-field> -->


          </div>
          <!-- </mat-card> -->


          <div class="float-button-container" *ngIf='isList'>
            <button mat-fab color="primary" aria-label="add" (click)="newProduct()">
              <mat-icon>plus_one</mat-icon>
            </button>
          </div>
          <div class="float-button-container" *ngIf='!isList'>
            <button mat-fab color="primary" aria-label="save" (click)="saveProduct()">
              <mat-icon>save</mat-icon>
            </button>
            <!-- <button mat-fab color="primary" aria-label="save" (click)="logProducts()">
              <mat-icon>save</mat-icon>
            </button> -->
          </div>
        </div>

      </div>
    </div>
  </div>


</div>